module.exports = __webpack_public_path__ + "img/favorites.5deecba5.svg";